type UnauthorizedHandler = () => void;

let handler: UnauthorizedHandler | null = null;

export const setUnauthorizedHandler = (unauthorizedHandler: UnauthorizedHandler | null) => {
  handler = unauthorizedHandler;
};

export const notifyUnauthorized = () => {
  handler?.();
};
